//首页
export function loadHomeBannerList() {
  return {
    type: 'LOAD_HOME_BANNER_LIST',
  };
}

export function loadHomeBannerListCompletion(data, error) {
  return {
    type: 'LOAD_HOME_BANNER_LIST_COMPLETION',
    list: (data && data.listData) || [],
    error,
  };
}

//小程序banner图
export function loadWeappBannerList() {
  return {
    type: 'LOAD_WEAPP_BANNER_LIST',
  };
}

export function loadWeappBannerListCompletion(error, list) {
  return {
    type: 'LOAD_WEAPP_BANNER_LIST_COMPLETION',
    error,
    list,
  };
}

export function loadImgGroupList() {
  return {
    type: 'LOAD_IMGGROUP_LIST',
  };
}

export function loadImgGroupListCompletion(data, error) {
  return {
    type: 'LOAD_IMGGROUP_LIST_COMPLETION',
    list: (data && data.listData) || [],
    error,
  };
}

export function loadKillList() {
  return {
    type: 'LOAD_KILL_LIST',
  };
}

export function loadKillListCompletion(data, error) {
  return {
    type: 'LOAD_KILL_LIST_COMPLETION',
    data,
    error,
  };
}

export function loadHomeGroupList(query) {
  return {
    type: 'LOAD_HOME_GROUP_LIST',
    query,
    willReload: !!query,
  };
}

export function loadHomeGroupListCompletion(error, list, topicVo) {
  return {
    type: 'LOAD_HOME_GROUP_LIST_COMPLETION',
    error,
    list,
    topicVo,
  };
}

export function loadLimitProductList() {
  return {
    type: 'LOAD_LIMIT_PRODUCT_LIST',
  };
}

export function loadLimitProductListCompletion(error, data) {
  return {
    type: 'LOAD_LIMIT_PRODUCT_LIST_COMPLETION',
    error,
    list: (data && data.listData) || [],
  };
}

export function loadHomeThemeList() {
  return {
    type: 'LOAD_HOME_THEME_LIST',
  };
}

export function loadHomeThemeListCompletion(error, data) {
  return {
    type: 'LOAD_HOME_THEME_LIST_COMPLETION',
    error,
    data,
  };
}

export function loadWeappHomeThemeList() {
  return {
    type: 'LOAD_WEAPP_HOME_THEME_LIST',
  };
}

export function loadWeappHomeThemeListCompletion(error, data) {
  return {
    type: 'LOAD_WEAPP_HOME_THEME_LIST_COMPLETION',
    error,
    data,
  };
}

export function loadHomeCategoryList() {
  return {
    type: 'LOAD_HOME_CATEGORY_LIST',
  };
}

export function loadHomeCategoryListCompletion(error, list) {
  return {
    type: 'LOAD_HOME_CATEGORY_LIST_COMPLETION',
    error,
    list,
  };
}

export function loadHomeProductList(id) {
  return {
    type: 'LOAD_HOME_PRODUCT_LIST',
    id,
  };
}

export function loadHomeProductListCompletion(error, list) {
  return {
    type: 'LOAD_HOME_PRODUCT_LIST_COMPLETION',
    error,
    list,
  };
}

export function loadHomeMall(reload) {
  return {
    type: 'LOAD_HOME_MALL',
    reload,
  };
}

export function loadHomeMallCompletion(error, data, didLoadAt) {
  return {
    type: 'LOAD_HOME_MALL_COMPLETION',
    error,
    data,
    didLoadAt,
  };
}

export function loadWeappHomeMall(reload) {
  return {
    type: 'LOAD_WEAPP_HOME_MALL',
    reload,
  };
}

export function loadWeappHomeMallCompletion(error, data, didLoadAt) {
  return {
    type: 'LOAD_WEAPP_HOME_MALL_COMPLETION',
    error,
    data,
    didLoadAt,
  };
}

export function loadPresaleList() {
  return {
    type: 'LOAD_PRESALE_LIST',
  };
}

export function loadPresaleListCompletion(error, list) {
  return {
    type: 'LOAD_PRESALE_LIST_COMPLETION',
    error,
    list,
  };
}
